import { createEvent, createStore } from 'effector';

interface ViewModeDefault {
  type: 'default';
}
interface ViewModeContent {
  type: 'content-zoom';
}
interface ViewModeBlock {
  type: 'block-zoom';
  blockId: string;
}

interface ViewModePreview {
  type: 'preview';
}

type ViewMode = ViewModeDefault | ViewModeContent | ViewModeBlock | ViewModePreview;

export const tooglePreviewFullscreenEvent = createEvent();
export const setPreviewFullscreenEvent = createEvent<boolean>();
export const setCustomizerPreviewModeEvent = createEvent<ViewMode>();
export const updatePreviewEvent = createEvent<{
  url?: string;
  fullsceen?: boolean;
  firstView?: boolean;
  scale?: number;
  height?: number;
  width?: number;
}>();

export interface CustomizerPreviewStore {
  url: string;
  fullsceen: boolean;
  firstView: boolean;
  scale: number;
  height: number;
  width: number;
  viewMode: ViewMode;
}

export const initialCustomizerPreviewStore: CustomizerPreviewStore = {
  url: '',
  fullsceen: false,
  firstView: false,
  scale: 0,
  height: 0,
  width: 1536,
  viewMode: { type: 'default' },
};

export const $customizerPreviewStore = createStore(initialCustomizerPreviewStore)
  .on(tooglePreviewFullscreenEvent, (state) => {
    return { ...state, fullsceen: !state.fullsceen, firstView: false };
  })
  .on(setPreviewFullscreenEvent, (state, status) => {
    return { ...state, fullsceen: status, firstView: false };
  })
  .on(updatePreviewEvent, (state, params) => {
    return { ...state, ...params };
  })
  .on(setCustomizerPreviewModeEvent, (state, viewMode) => {
    return { ...state, viewMode };
  });

export const $customizerPreviewFullscreen = $customizerPreviewStore.map((state) => state.viewMode.type === 'preview');
export const $customizerPreviewFirstView = $customizerPreviewStore.map((state) => state.firstView);
export const $customizerPreviewPortalUrl = $customizerPreviewStore.map((state) => state.url);
export const $customizerPreviewScale = $customizerPreviewStore.map((state) => state.scale);
export const $customizerPreviewScaledHeight = $customizerPreviewStore.map((state) => Math.ceil(state.height));
export const $customizerPreviewWidth = $customizerPreviewStore.map((state) => state.width);
export const $customizerPreviewMode = $customizerPreviewStore.map((state) => state.viewMode);
